module.exports = __webpack_public_path__ + "assets/ico-parkdetail.dd7fcbc3.svg";